export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=ccc2baa8"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Quotations/index.vue?vue&type=template&id=ccc2baa8
// module id = 2315
// module chunks = 31